import React from 'react';
import { useSelector } from 'react-redux';

import { CarrierColumnContainer } from '../../../containers/carrier-column-container';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const CarrierColumn = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret) {
    return '';
  }

  const { returnConfiguration } = ret || {};
  const { carrierId, labelProviderId: providerId } = returnConfiguration || {};

  if (!carrierId || !providerId) {
    return '';
  }

  return <CarrierColumnContainer carrierId={carrierId} providerId={providerId} />;
};

export const Carrier = {
  getMessageDescriptor: () => messages.carrier,
  id: 'carrier',

  render: ({ fulfillmentId }) => {
    return <CarrierColumn fulfillmentId={fulfillmentId} />;
  },
};
